/**
 * App shell: Sidebar, user popover, mobile top bar, impersonation banner,
 * access gate, not-found page. Keys must match ../en/shell.ts.
 */
const shell = {
  notFound: '页面不存在',
  nav: {
    label: '主导航',
    workspace: '工作区',
    skills: '技能中心',
    tasks: '任务',
    eval: '评测',
    feedback: '反馈',
    comingSoon: '{{label}}（即将上线）',
    closeMenu: '关闭导航菜单',
    openMenu: '打开导航菜单',
    home: 'Rocky 首页',
    logoAlt: 'Rocky',
  },
  user: {
    viewingAs: '正在以 {{alias}} 的身份查看',
    fallbackName: '用户',
  },
  popover: {
    close: '关闭',
    accountSettings: '账户与设置',
    backendManagement: '后台管理系统',
    switchAgent: '切换 Agent',
    language: '语言',
    viewAsOther: '以其他用户身份查看',
    aliasPlaceholder: '输入 alias…',
    go: '查看',
    aliasInvalid: 'login 只能包含字母、数字、点、短横线或下划线，不能有空格或 @。',
    exitViewing: '退出查看模式',
  },
  mobileTopBar: {
    files: '文件',
    openChat: '打开对话',
  },
  impersonation: {
    banner: '管理员查看模式：<strong>{{alias}}</strong>',
    exitLabel: '退出查看模式',
    exit: '退出',
  },
  accessGate: {
    noAccess: '当前账号 <strong>{{uid}}</strong> 暂未开通 Rocky 访问权限',
    intro:
      '<strong>Rocky 是 CMHK 的个人助理，</strong>无需复杂的安装手续，<strong>开箱即用，</strong>所有数据与 skills 预配置好，专注于适配您本人与团队的资讯与分析。（<site>https://rocky.ai.aws.dev/</site>）',
    sources: '目前已接入数据 / 外部资讯：',
    wechat: '微信公众号',
    custom: '您也可以联系我们，轻松构建适合自己团队的报告和新闻渠道并进行分发。',
    trial:
      '<strong>我们欢迎您的试用。</strong>请在<quip> Quip </quip>内填入您的 login 即可，Rocky 会在 1 个工作日内自动与您联系。 您也可以直接与我们（<strong>@tiancho</strong>, <strong>@qiuyac</strong>）取得联系。',
    slides: {
      workspace: { caption: 'Rocky 工作区', alt: 'Rocky Portal 工作区界面' },
      weekly: { caption: '每周用量与收入报告', alt: '每周用量与收入报告示例' },
      forecast: { caption: '基线预测报告', alt: '基线预测报告示例' },
    },
    footer: 'CMHK Agent Platform · 为您的团队打造',
  },
};

export default shell;
